<template>
  <footer class="app-footer">
    <div class="container-fluid">
      <div class="row g-2 align-items-center">
        <div class="col-12 col-lg-6">
          <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
            <div class="app-footer__brand">
              MANET Marketing GmbH
              <span class="mx-2"><Icon icon="fa-pro-solid:heart" /></span>
            </div>
            <div class="app-footer__meta">
              Ihr Partner für Softwareentwicklung und Marketing
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="app-footer__copyright">
            &copy; {{ currentYear }}
            <a
              href="https://manet-marketing.de/"
              target="_blank"
              rel="noopener noreferrer"
              class="app-footer__link"
            >
              MANET Marketing GmbH
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
.app-footer {
  padding: 1rem 0;
}
.app-footer__brand {
  font-size: 1rem;
  font-weight: 700;
  color: #16324a;
}

.app-footer__meta,
.app-footer__copyright {
  color: #5f7283;
  font-size: 0.95rem;
}

.app-footer__link {
  color: #0a5c83;
  font-weight: 600;
  text-decoration: none;
  word-break: break-word;
}

.app-footer__link:hover,
.app-footer__link:focus {
  color: #04355e;
  text-decoration: underline;
}

@media (max-width: 991.98px) {
  .app-footer {
    padding-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  .app-footer__copyright {
    text-align: right;
  }
}
</style>
